import React from 'react';
import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {ItemAssignmentForm} from 'src/app/item-tracker/ItemAssignmentForm';
import {itemAssignmentDocumentTitle} from 'src/app/item-tracker/itemAssignmentHelpers';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

const ItemAssignmentViewPage: React.FC = () => {
  useSetDocumentTitle(`${itemAssignmentDocumentTitle} - View`);
  const {definitionId, id} = useParams();

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.ItemTracker}>
      {id !== undefined && (
        <ItemAssignmentForm
          definitionId={Number(definitionId)}
          id={Number(id)}
          mode="view"
          enableEdit={true}
          enableTransitions={true}
        />
      )}
    </ContentWrapper>
  );
};

export default ItemAssignmentViewPage;

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.ItemAssignmentView(':definitionId', ':id'),
  element: <ItemAssignmentViewPage />,
  isPrivate: true,
  module: ModuleEnum.ItemTrackerAssignments,
  operation: PermissionOperationEnum.View,
});
